export const formatLocation = (city, state) => {
  const trimmedCity = city?.trim();
  const trimmedState = state?.trim();

  if (!trimmedCity && !trimmedState) return "N/A";
  if (trimmedCity && trimmedState) return `${trimmedCity}, ${trimmedState}`;
  return trimmedCity || trimmedState;
};
